export const tableHeader = {
  'Surname': 'surname',
  'Name': 'name',
  'Country': 'country',
  'Post code': 'postCode',
  'City': 'city',
  'Phone': 'phone',
};
